import { v4 as uuidv4 } from 'uuid';
import type { RetirementConfig } from '../fin/retirement_config.ts';
import * as w from './worker.ts';

export type Listener = {
  completionHandler: (r: w.TaskResponseMessage) => void;
  failureHandler: () => void;
  progressHandler: (progress: number) => void;
};

const tasks = new Map<w.RequestId, {listener: Listener; worker: Worker}>();

function getNewWorker(): Worker {
  const worker = new Worker(
    new URL(
      'server.ts',
      import.meta.url,
    ),
    {type: 'module'},
  );

  worker.addEventListener('message', ev => {
    const r = JSON.parse(ev.data as string) as w.TaskResponseMessage;
    const task = tasks.get(r.uuid);
    console.debug('client got message from worker');

    if (task?.listener === undefined) {
      console.warn(`got message for defunct listener ${r.uuid}`);
      return;
    }

    switch (r.status) {
      case w.TaskStatus.Failed: {
        task.listener.failureHandler();
        tasks.delete(r.uuid);
        break;
      }

      case w.TaskStatus.Complete: {
        task.listener.completionHandler(r);
        tasks.delete(r.uuid);
        break;
      }

      case w.TaskStatus.Progressing: {
        task.listener.progressHandler(r.progress);
        break;
      }
    }
  });

  return worker;
}

export function requestMonteCarloRetirement(
  config: RetirementConfig,
  listener: Listener,
): string {
  const serializedParams = config.serialize();
  const uuid = uuidv4();
  const worker = getNewWorker();
  tasks.set(uuid, {listener, worker});
  console.log('sending message to worker');

  worker.postMessage({
    action: w.WorkerAction.MontecarloRetirement,
    uuid,
    serializedParams,
  });

  console.log('sent message to worker');

  return uuid;
}

export function cancelTask(uuid: string): void {
  if (tasks.has(uuid)) {
    const task = tasks.get(uuid)!;
    task.worker.terminate();
    tasks.delete(uuid);
    console.log(`cancelled task ${uuid}`);
  } else {
    console.log(`worker.client.cancelTask not found: ${uuid}`);
  }
}
